import PogPeriod from './PogPeriod';

export default PogPeriod;
